import { api } from '@/shared/api/axios';

/** A document number such as "DT/INV/2026-27/001" made safe to use as a file name. */
export function pdfFileName(name: string, fallback = 'document'): string {
  const base = name.replace(/[\\/:*?"<>|\s]+/g, '-').replace(/^-+|-+$/g, '') || fallback;
  return `${base}.pdf`;
}

/** Turns a finished document page into a PDF on the server and saves it as `fileName` (a .pdf name). */
export async function downloadHtmlAsPdf(html: string, fileName: string): Promise<void> {
  const res = await api.post<Blob>('/sales-documents/pdf', { html }, { responseType: 'blob', skipErrorToast: true } as any);
  const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    URL.revokeObjectURL(url);
  }
}
